import React, { forwardRef, useCallback, useImperativeHandle, useRef } from 'react';
import { FlatList, FlatListProps } from 'react-native';
import ScrollContextProvider from './ScrollContextProvider';

// Define your own props type
export type PRFlatListOwnProps = {};

// Extend the FlatListProps with your own props
export type PRFlatListProps<TData> = PRFlatListOwnProps & FlatListProps<TData>;

// Define the component as a generic function and type it with forwardRef
function PRFlatList<TData>(props: PRFlatListProps<TData>, ref: React.Ref<FlatList<TData>>) {
    const localRef = useRef<FlatList>(null);

    // Normalize the forwarded ref
    useImperativeHandle(ref, () => localRef.current as FlatList);

    const renderFlatList = useCallback(
        (onScroll: () => void) => {
            const { children, ...toPass } = props;
            return (
                <FlatList
                    {...toPass}
                    onScroll={(e) => {
                        onScroll();
                        props.onScroll?.(e);
                    }}
                    ref={localRef}
                    scrollEventThrottle={30}
                >
                    {children}
                </FlatList>
            );
        },
        [props],
    );

    return <ScrollContextProvider scrollRef={localRef}>{renderFlatList}</ScrollContextProvider>;
}

// Use forwardRef with the generic component
export default forwardRef(PRFlatList) as <TData>(
    props: PRFlatListProps<TData> & { ref?: React.Ref<FlatList<TData>> },
) => React.ReactElement;
